import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";


export const GetDriveService=async(page,text,from_date,to_date,currentFolder)=>{
    try {
        const result = await get(`api/folder/get?page=${page}&search=${text}&from_date=${from_date}&to_date=${to_date}&currentFolder=${currentFolder}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetStarredDriveService=async(page,text,from_date,to_date)=>{
    try {
        const result = await get(`api/folder/get_starred?page=${page}&search=${text}&from_date=${from_date}&to_date=${to_date}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetDeletedDriveService=async(page,text,from_date,to_date)=>{
    try {
        const result = await get(`api/folder/get_deleted?page=${page}&search=${text}&from_date=${from_date}&to_date=${to_date}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const CreateDriveService=async(data)=>{
    try {
        const result = await post(`api/folder/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateDriveService=async(data,id)=>{
    try {
        const result = await put(`api/folder/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteDriveService=async(id)=>{
    try {
        const result = await put(`api/folder/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteAdminDriveService=async(id)=>{
    try {
        const result = await deleteRequest(`api/folder/delete1/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadDriveFileService=async(data)=>{
    try {
        const result = await postfd(`api/folder/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}